import moment from "moment";
import { clone, getBase64ImageWithHeader } from "../../utils";
import { getDefaultPhoto } from "./noteActions";
import { getDefaultUserAndRights } from "./siteMonitoringActions";

export function adaptSiteMonitoringForDb(siteMonitoring) {
	let newSiteMonitoring = clone(siteMonitoring);
	newSiteMonitoring.date_start = siteMonitoring.date_start
		? moment(siteMonitoring.date_start).format("YYYY-MM-DD HH:mm:ss")
		: undefined;
	newSiteMonitoring.date = siteMonitoring.date
		? moment(siteMonitoring.date).format("YYYY-MM-DD HH:mm:ss")
		: undefined;
	delete newSiteMonitoring.lot_ids;
	delete newSiteMonitoring.note_ids;
	return newSiteMonitoring;
}

export function adaptSiteMonitoringForMyOpen(siteMonitoring) {
	let newSiteMonitoring = clone(siteMonitoring);
	newSiteMonitoring.date_start = moment(
		moment.utc(newSiteMonitoring.date_start, "YYYY-MM-DD").local()
	);
	newSiteMonitoring.date = moment(
		moment.utc(newSiteMonitoring.date, "YYYY-MM-DD").local()
	);
	return newSiteMonitoring;
}

export function adaptSiteMonitoringFromOpenERP(siteMonitoring) {
	let newSiteMonitoring = adaptSiteMonitoringForMyOpen(siteMonitoring);
	newSiteMonitoring.site_supervision_authorized_user_ids.push(
		getDefaultUserAndRights(siteMonitoring.id)
	);
	return newSiteMonitoring;
}

export function adaptLotForMyOpen(lot) {
	let newLot = clone(lot);
	return newLot;
}

export function adaptLotForDb(lot) {
	let newLot = clone(lot);
	return newLot;
}

export function adaptLotForOpenERP(lot) {
	let clonedLot = clone(lot);
	return clonedLot;
}

export function adaptNoteForMyOpen(note) {
	let newNote = clone(note);
	newNote.date_deadline = moment(
		moment.utc(newNote.date_deadline, "YYYY-MM-DD HH:mm:ss").local()
	);
	newNote.create_date = moment(
		moment.utc(newNote.create_date, "YYYY-MM-DD HH:mm:ss").local()
	);

	return newNote;
}

export function adaptNoteFromOpenERP(note) {
	let newNote = adaptNoteForMyOpen(note);
	newNote.category_ids = newNote.category_ids.map((c) => c.id);
	newNote.document_ids.push(getDefaultPhoto());
	newNote.assigned_user_id = newNote.assigned_user_id.id;

	newNote.document_ids.forEach((d) => {
		d.file_id = d.file_id ? getBase64ImageWithHeader(d.file_id) : "";
	});

	return newNote;
}

export function adaptNoteForDb(note) {
	let newNote = clone(note);
	delete newNote.creating;
	newNote.date_deadline = note.date_deadline
		? moment(note.date_deadline).format("YYYY-MM-DD HH:mm:ss")
		: undefined;
	newNote.create_date = note.create_date
		? moment(note.create_date).format("YYYY-MM-DD HH:mm:ss")
		: undefined;
	return newNote;
}

export function adaptNoteForOpenERP(note) {
	let clonedNote = clone(note);
	clonedNote.date_deadline = note.date_deadline.format("YYYY-MM-DD HH:mm:ss");
	clonedNote.create_date = note.create_date.format("YYYY-MM-DD HH:mm:ss");

	clonedNote.document_ids = [];

	note.document_ids
		.filter((d) => d.guid || d.id)
		.forEach((d) => {
			let newDocument = clone(d);
			if (newDocument.file_id)
				newDocument.file_id = newDocument.file_id.replace(
					/^data:image[\/]*[a-z]*;base64,/,
					""
				);

			clonedNote.document_ids.push(newDocument);
		});

	return clonedNote;
}

export function adaptPlanFromOpenERP(plan) {
	let newPlan = adaptPlanForMyOpen(plan);
	newPlan.data = plan.data ? JSON.parse(plan.data) : null;
	return newPlan;
}

export function adaptPlanForMyOpen(plan) {
	let clonedPlan = clone(plan);
	clonedPlan.create_date = moment(
		moment.utc(clonedPlan.create_date, "YYYY-MM-DD").local()
	);
	clonedPlan.file_id = clonedPlan.file_id
		? getBase64ImageWithHeader(plan.file_id)
		: "";
	return clonedPlan;
}

export function adaptPlanForDb(plan) {
	let clonedPlan = clone(plan);
	clonedPlan.create_date = plan.create_date
		? plan.create_date.format("YYYY-MM-DD HH:mm:ss")
		: undefined;
	return clonedPlan;
}

export function adaptPlanForOpenERP(plan) {
	let clonedPlan = clone(plan);
	clonedPlan.create_date = plan.create_date.format("YYYY-MM-DD HH:mm:ss");
	if (plan.file_id)
		clonedPlan.plan_file_id = plan.file_id.replace(
			/^data:image[\/]*[a-z]*;base64,/,
			""
		);// eslint-disable-line
	delete clonedPlan.file_id;
	clonedPlan.plan_filename = clonedPlan.name + ".jpg";
	clonedPlan.data = plan.data ? JSON.stringify(plan.data) : null;
	return clonedPlan;
}

export function adaptCommentForMyOpen(comment) {
	let newComment = clone(comment);
	newComment.date = moment(
		moment.utc(newComment.date, "YYYY-MM-DD HH:mm:ss").local()
	);

	return newComment;
}

export function adaptCommentForDb(comment) {
	let newComment = clone(comment);
	delete newComment.creating;
	newComment.date = comment.date
		? moment(comment.date).format("YYYY-MM-DD HH:mm:ss")
		: undefined;

	return newComment;
}

export function adaptCommentForOpenERP(comment) {
	let clonedComment = clone(comment);
	clonedComment.date = comment.date.format("YYYY-MM-DD HH:mm:ss");
	return clonedComment;
}

export function adaptUserAndRightsForOpenERP(userAndRights) {
	let clonedUserAndRights = clone(userAndRights);
	clonedUserAndRights.user_id = clonedUserAndRights.user_id.id;
	return clonedUserAndRights;
}

export function adaptUserAndRightsForMyOpen(userAndRights) {
	let clonedUserAndRights = clone(userAndRights);

	return clonedUserAndRights;
}
